module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kobe-html-report"
  }, [(_vm.showLogin) ? _c('report-login-modal', {
    attrs: {
      "value": _vm.showLogin,
      "campaignID": _vm.campaignID
    },
    on: {
      "loggedIn": _vm.onLoggedIn,
      "input": function () {}
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "state"
  }, [_vm._v("Generating report…")]) : (_vm.error) ? _c('div', {
    staticClass: "state error"
  }, [_vm._v(_vm._s(_vm.error))]) : (_vm.html) ? _c('iframe', {
    ref: "frame",
    staticClass: "report-frame",
    attrs: {
      "srcdoc": _vm.html,
      "frameborder": "0"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-495b8751"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/HtmlReport.vue
// module id = 2108
// module chunks = 0